/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import JoditEditor from "jodit-react";

//This defaultButtonsList is an optional alternative to the button arrangement.
const defaultButtonsList = [
    "source",
    "|",
    "bold",
    "italic",
    "underline",
    "strikethrough",
    "|",
    "ul",
    "ol",
    "|",
    "outdent",
    "indent",
    "|",
    "font",
    "fontsize",
    "brush",
    "paragraph",
    "|",
    "image",
    "table",
    "link",
    "|",
    "align",
    "undo",
    "redo",
    "|",
    "hr",
    "eraser",
    "copyformat",
    "|",
    "fullsize",
];

const config = {
    readonly: false, // all options from https://xdsoft.net/jodit/docs/,
    toolbar: true,
    spellcheck: true,
    language: "en",
    toolbarButtonSize: "medium",
    toolbarAdaptive: false,
    showCharsCounter: true,
    showWordsCounter: true,
    showXPathInStatusbar: false,
    askBeforePasteHTML: true,
    askBeforePasteFromWord: true,
    defaultActionOnPaste: "insert_clear_html",
    uploader: {
        insertImageAsBase64URI: true,
    },
    beautifyHTML: true,
    useSearch: true,
    disablePlugins: "video,file,print",
    placeholder: '', //elementName ||
    addNewLine: false
};

const JoditField = ({ startingValue, setContentState }) => {

    const editor = useRef(null);

    /*
        const onBlurEditor = (newValue, event) => {
            if (startingValue !== newValue || newValue !== "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[No data.]</p></div>") {
                if (event.preventDefault) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                newValue = newValue.replaceAll(" < ", " &lt; ").replaceAll(" > ", " &gt; ").replaceAll(" & ", " &amp; ");
                editor.current.value = newValue;
                setResourceState(prevState => { return { ...prevState, [elementName]: newValue } });
            }
        };
    */

    return <JoditEditor
        ref={editor}
        value={startingValue}
        config={config}
        tabIndex={1} // tabIndex of textarea
        //onBlur={onBlurEditor}
        onChange={(newContent) => setContentState(newContent)}
    />;
};
//XhtmlEntry startingValue is expecting a Narrative datatype div element value without the divWrapper
const XhtmlEntry = ({ elementName, startingValue, setResourceState }) => {

    const [contentState, setContentState] = useState("");
    const [startingValueState, setStartingValueState] = useState("");

    useEffect(() => {
        if (startingValue || startingValue === "") {
            let newValue = startingValue.replaceAll(" < ", " &lt; ").replaceAll(" > ", " &gt; ")
                .replaceAll(" & ", " &amp; ");
            setContentState(newValue);
            setStartingValueState(startingValue);
        }
    }, []);

    useEffect(() => {
        if (startingValueState || contentState) {
     //   if (startingValueState !== contentState) {
            let newValue = contentState.replaceAll(" < ", " &lt; ").replaceAll(" > ", " &gt; ")
                .replaceAll(" & ", " &amp; ")
                .replaceAll("&nbsp;", "&#160;")
                .replaceAll("<br></p>", " &#160; </p>").replaceAll("<p><br>", "<p> &#160; ").replaceAll("<br>", "<p> &#160; </p>");
            setResourceState(prevState => { return { ...prevState, [elementName]: newValue } });
     //   }
        }
    }, [contentState]);

    return <div>
        {(startingValueState || startingValueState === "") &&
            <>
                <JoditField
                    elementName={elementName} startingValue={startingValueState}
                    setContentState={setContentState} />
                <br />
            </>}
    </div>
};

export default XhtmlEntry;